/* tslint:disable */
/* eslint-disable */
/**
 * Products API
 * API for managing products
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NoticePeriodDurationDto } from './NoticePeriodDurationDto';
import {
    NoticePeriodDurationDtoFromJSON,
    NoticePeriodDurationDtoFromJSONTyped,
    NoticePeriodDurationDtoToJSON,
    NoticePeriodDurationDtoToJSONTyped,
} from './NoticePeriodDurationDto';
import type { TargetedSubscriberEnum } from './TargetedSubscriberEnum';
import {
    TargetedSubscriberEnumFromJSON,
    TargetedSubscriberEnumFromJSONTyped,
    TargetedSubscriberEnumToJSON,
    TargetedSubscriberEnumToJSONTyped,
} from './TargetedSubscriberEnum';

/**
 * 
 * @export
 * @interface CreateProductCommand
 */
export interface CreateProductCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateProductCommand
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductCommand
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductCommand
     */
    summary: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductCommand
     */
    fullDescription?: string;
    /**
     * Product logo, required.
     * @type {string}
     * @memberof CreateProductCommand
     */
    storedFileId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductCommand
     */
    branchId: string;
    /**
     * Personne owning the product.
     * @type {string}
     * @memberof CreateProductCommand
     */
    personId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductCommand
     */
    isTacitRenewal: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductCommand
     */
    isFixedFormula?: boolean;
    /**
     * 
     * @type {TargetedSubscriberEnum}
     * @memberof CreateProductCommand
     */
    targetedSubscriber?: TargetedSubscriberEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateProductCommand
     */
    plateformeIds: Array<string>;
    /**
     * 
     * @type {NoticePeriodDurationDto}
     * @memberof CreateProductCommand
     */
    noticePeriodDuration: NoticePeriodDurationDto;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductCommand
     */
    isSepaActivated?: boolean;
}



/**
 * Check if a given object implements the CreateProductCommand interface.
 */
export function instanceOfCreateProductCommand(value: object): value is CreateProductCommand {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('summary' in value) || value['summary'] === undefined) return false;
    if (!('storedFileId' in value) || value['storedFileId'] === undefined) return false;
    if (!('branchId' in value) || value['branchId'] === undefined) return false;
    if (!('personId' in value) || value['personId'] === undefined) return false;
    if (!('isTacitRenewal' in value) || value['isTacitRenewal'] === undefined) return false;
    if (!('plateformeIds' in value) || value['plateformeIds'] === undefined) return false;
    if (!('noticePeriodDuration' in value) || value['noticePeriodDuration'] === undefined) return false;
    return true;
}

export function CreateProductCommandFromJSON(json: any): CreateProductCommand {
    return CreateProductCommandFromJSONTyped(json, false);
}

export function CreateProductCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateProductCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'code': json['code'],
        'summary': json['summary'],
        'fullDescription': json['fullDescription'] == null ? undefined : json['fullDescription'],
        'storedFileId': json['storedFileId'],
        'branchId': json['branchId'],
        'personId': json['personId'],
        'isTacitRenewal': json['isTacitRenewal'],
        'isFixedFormula': json['isFixedFormula'] == null ? undefined : json['isFixedFormula'],
        'targetedSubscriber': json['targetedSubscriber'] == null ? undefined : TargetedSubscriberEnumFromJSON(json['targetedSubscriber']),
        'plateformeIds': json['plateformeIds'],
        'noticePeriodDuration': NoticePeriodDurationDtoFromJSON(json['noticePeriodDuration']),
        'isSepaActivated': json['isSepaActivated'] == null ? undefined : json['isSepaActivated'],
    };
}

export function CreateProductCommandToJSON(json: any): CreateProductCommand {
    return CreateProductCommandToJSONTyped(json, false);
}

export function CreateProductCommandToJSONTyped(value?: CreateProductCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'code': value['code'],
        'summary': value['summary'],
        'fullDescription': value['fullDescription'],
        'storedFileId': value['storedFileId'],
        'branchId': value['branchId'],
        'personId': value['personId'],
        'isTacitRenewal': value['isTacitRenewal'],
        'isFixedFormula': value['isFixedFormula'],
        'targetedSubscriber': TargetedSubscriberEnumToJSON(value['targetedSubscriber']),
        'plateformeIds': value['plateformeIds'],
        'noticePeriodDuration': NoticePeriodDurationDtoToJSON(value['noticePeriodDuration']),
        'isSepaActivated': value['isSepaActivated'],
    };
}

